export const extractMenuItems = (menu: {
  attributes: { items: { label: string; uri: string }[] }
}) =>
  menu.attributes.items.map(
    ({ label, uri }: { label: string; uri: string }) => ({
      href: uri,
      children: label,
    }),
  )
